var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackstoryChapterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.904297,
    y: 0.761719,
    width: 54.1558,
    height: 55.1587,
    rx: 7.25149,
    fill: "#C0D8D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25024,
    y: 9.68359,
    width: 37.1068,
    height: 34.0981,
    rx: 2.09679,
    fill: "url(#paint0_linear_1255_9128)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25024,
    y: 9.68359,
    width: 37.1068,
    height: 34.0981,
    rx: 2.09679,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.256 43.7812C10.1483 43.7812 9.25024 42.8832 9.25024 41.7755V11.6889C9.25024 10.5812 10.1483 9.68315 11.256 9.68315H18.2762V43.7812H11.256Z",
    fill: "#619D94"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.282,
    y: 21.7188,
    width: 23.0664,
    height: 2.00577,
    rx: 1.00289,
    fill: "url(#paint1_linear_1255_9128)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.282,
    y: 21.7188,
    width: 23.0664,
    height: 2.00577,
    rx: 1.00289,
    fill: "black",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.282,
    y: 26.7344,
    width: 18.0519,
    height: 2.00577,
    rx: 1.00289,
    fill: "url(#paint2_linear_1255_9128)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.282,
    y: 31.7461,
    width: 7.0202,
    height: 2.00577,
    rx: 1.00289,
    fill: "url(#paint3_linear_1255_9128)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0327 16.1303L32.9859 18.5551C32.5881 19.0333 31.9982 19.3099 31.3761 19.3099C30.754 19.3099 30.1641 19.0333 29.7662 18.5551L27.8059 16.1934C27.4548 15.7723 27.2761 15.2338 27.3052 14.6864C27.3344 14.1388 27.5695 13.6227 27.9635 13.2413C28.3897 12.8485 28.9604 12.6516 29.5378 12.6981C30.1179 12.7404 30.6528 13.0265 31.01 13.4853L31.4194 13.9734L31.7658 13.5561C32.1064 13.1265 32.5973 12.842 33.1393 12.7602C33.6814 12.6785 34.2343 12.8052 34.6864 13.1152C35.1326 13.4695 35.4165 13.9892 35.4736 14.556C35.5479 15.119 35.3886 15.6879 35.0328 16.1303H35.0327Z",
    fill: "url(#paint4_linear_1255_9128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1255_9128",
    x1: 16.8741,
    y1: 9.68359,
    x2: 47.6021,
    y2: 47.1473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1255_9128",
    x1: 25.0211,
    y1: 21.7188,
    x2: 25.3055,
    y2: 25.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABEEE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1255_9128",
    x1: 29.3079,
    y1: 26.7344,
    x2: 29.7075,
    y2: 29.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96CEC5",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1255_9128",
    x1: 23.7921,
    y1: 31.7461,
    x2: 23.7921,
    y2: 33.7519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#619D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1255_9128",
    x1: 31.3968,
    y1: 12.6914,
    x2: 31.3968,
    y2: 19.3099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#619D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackstoryChapterIcon);
export default __webpack_public_path__ + "static/media/backstoryChapterIcon.79f9bcc1b9ac43793d76337436dfd34c.svg";
export { ForwardRef as ReactComponent };